import OVdxbModal from './index.vue';

OVdxbModal.install = app => {
  app.component(OVdxbModal.name, OVdxbModal);
};

export default OVdxbModal;
